import React from 'react';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import Modal from '@mos-cat/modal';
import { Trans } from '@lingui/macro';
import { Button, Heading } from '@mos-cat/typography';

import { errorSubmitModalOpen } from '../../../models/modals';
import Error from './icon/Error';
import ErrorMobile from './icon/ErrorMobile';
import './ErrorModal.pcss';

interface Props {
  isVisible: boolean;
  onModalClose(): void;
}

function ErrorModal({ isVisible, onModalClose }: Props) {
  return (
    <Modal
      headerContent={null}
      visible={isVisible}
      onClose={onModalClose}
      className={isVisible ? 'ErrorSubmitModal' : ''}
    >
      <ErrorMobile
        className="ErrorMobileIcon"
        style={{ width: '25px', height: '25px' }}
      />
      <Error className="ErrorIcon" style={{ width: '64px', height: '64px' }} />
      <Heading level={2} className="ErrorSubmitModal__title">
        <Trans>Заявление не удалось отправить</Trans>
      </Heading>
      <div className="ErrorSubmitModal__text">
        <Trans>
          Произошла ошибка и заявление не удалось отправить. Пожалуйста,
          повторите попытку.
        </Trans>
      </div>
      <Button primary className="ErrorSubmitModal__btn" onClick={onModalClose}>
        Закрыть
      </Button>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onModalClose() {
    dispatch(errorSubmitModalOpen(false));
  }
});

export default connect(
  state => {
    return {
      isVisible: state.modals.errorSubmitModalOpen
    };
  },
  mapDispatchToProps
)(ErrorModal);
